import React, {useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import Stepper from '../../../components/stepper/Stepper';
import {promoResponse} from '../../../redux/checkoutSlice';
import OrderSummary from './OrderSummary';
import Thankyou from './Thankyou';
import GreenCheckIcon from '../../../assets/images/green_icon.svg';
import WhatsappIcon from '../../../assets/images/whatsapp.svg';
import CustomModal from '../../../components/modal/CustomModal';
import {BackButtonAction} from '../../../core/utils/string.util';
import QRCode from 'react-qr-code';
import {
  eventNames,
  pageName,
  orderCompleteEvent,
  whatsAppStatusMesages,
} from '../../../lib/constants';
import {orderDetailInfo} from '../../../lib/types';
import {
  paymentModeData,
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {
  invoiceGeneratedResponse,
  invoiceGeneratedError,
  transactionStatusResponse,
  transactionStatusError,
  orderResponse,
  resetInvoiceResponse,
  resetOrderState,
  setCartItemsCount,
} from '../../../redux/orderSlice';
import Offer from './offer';
import {
  getStoreCode,
  getStoreInformation,
  getUserType,
  setpaymentConfirm,
  setStoreCode,
  setStoreInformation,
  setUserType,
  getPhoneNumber,
  setTotalCartItems,
  getAccessToken,
  setThankyou,
  getOrderResp,
} from '../../../core/localstorage-data';
import {
  checkWhatsappStatus,
  errorinwhatsapp,
  whatsApi,
  whatsappData,
  whatsAppEnrolledStatus,
} from '../../../redux/yellowMessengerSlice';

import {beginFeedback, checkoutGtmData, submitFeedback, whatsAppGtmStatus} from '../../../lib/tagmanager';
import {OrderResponse} from '../../../lib/order-types';
import {logout} from '../../../core/utils/routing.util';
import {setPageName} from '../../../lib/tagmanager';
import NegativeFeedback from '../feedback/NegativeFeedback';
import {feedbackCustomer} from '../../../redux/feedbackSlice';
import {
  smsorderIdBySms,
  ordersmsApiResponse,
  errorInOrderSmsApi,
  orderSmsLoading,
  resetOrderSmsState,
} from '../../../redux/ordersmsSlice';
import cogoToast from 'cogo-toast';
import SuccessToast from '../../../components/notifications/SuccessToast';
import ErrorToast from '../../../components/notifications/ErrorToast';

// type PaymentProps = {
//   children?: React.ReactNode;
//   className?: string;
//   onViewDetailsClicked: () => void;
//   onProceed: () => void;
//   totalAmount?: number;
// };
let timer11 = 0;
let thankyouTimer = 0;
declare const window: any;
const CheckoutConfirm = () => {
  const navigate = useHistory();
  const invoiceResp = useAppSelector(invoiceGeneratedResponse);
  const invoiGenerationError = useAppSelector(invoiceGeneratedError);

  const transactionStatusResp = useAppSelector(transactionStatusResponse);

  const transactionStatusRespError = useAppSelector(transactionStatusError);
  const orderResp = useAppSelector(orderResponse);
  const [priceDetails, setPriceDetails] = useState(null);
  const [showThankyou, setShowThankyou] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [thankYouType, setThankYouType] = useState<string | null>(null);
  const [optInTrue, setOptIn] = useState(true);
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const [showOrderSummaryModal, setShowOrderSummaryModal] = useState(false);
  const dispatch = useAppDispatch();
  const currentOrderResp = getOrderResp();

  const ordersmsApiResp = useAppSelector(ordersmsApiResponse);
  const OrderApiError = useAppSelector(errorInOrderSmsApi);
  const orderSmsApiLoaded = useAppSelector(orderSmsLoading);
  const userType = getUserType();
  const mobile = getPhoneNumber();
  const isWhatsappEnrolled = useAppSelector(whatsAppEnrolledStatus);
  const timeoutRef = useRef(null);
  const paymentMode = useAppSelector(paymentModeData);
  const [errorMessage, setErrorMessage] = useState(
    'Invoice generation is in process, it may take some time.',
  );

  const accessToken = getAccessToken();
  useEffect(() => {
    if (
      !invoiceResp &&
      !transactionStatusResp &&
      transactionStatusRespError == '' &&
      !invoiGenerationError
    ) {
      navigate.push('/checkout');
    }
  }, [
    invoiceResp,
    transactionStatusResp,
    transactionStatusRespError,
    invoiGenerationError,
  ]);
  useEffect(() => {
    if (invoiceResp && invoiceResp.couponIssuanceFlag === 'Y') {
      setShowOfferPopup(true);
      setShowThankyou(false);
    } else {
      setShowOfferPopup(false);
    }
  }, [invoiceResp]);
  useEffect(() => {
    if (
      ordersmsApiResp.resultCode == '200' &&
      ordersmsApiResp.resultMessage == 'success'
    ) {
      window.Moengage.destroy_session();
      cogoToast.success(
        <SuccessToast
          title="Success!"
          description="Order Id  Sent Successfully"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
      clearTimeout(timer11);

      thankyouTimer = window.setTimeout(() => {
        if (userType === 'employee') {
          const userType = getUserType();
          localStorage.clear();
          if (userType != null) {
            setUserType(userType);
            setThankyou();
            window.location.href = '/thankyou';
          }
        }
      }, 3000);
    }
    if (OrderApiError != '') {
      cogoToast.error(
        <ErrorToast
          title="Error!"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [ordersmsApiResp, OrderApiError, orderSmsApiLoaded]);

  useEffect(() => {
    if (userType === 'customer') {
      console.log('showOrderSummary modal', showOrderSummaryModal);
      if (timeoutRef.current !== null) {
        // IF THERE'S A RUNNING TIMEOUT
        clearTimeout(timeoutRef.current); // THEN, CANCEL IT
      }
      if (showOrderSummaryModal === false && showOfferPopup === false) {
        timeoutRef.current = setTimeout(() => {
          // SET A TIMEOUT
          timeoutRef.current = null; // RESET REF TO NULL WHEN IT RUNS
          setShowThankyou(true);
        }, 15000);
      }
    }
  }, [showOrderSummaryModal, showOfferPopup]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShowThankyou(true);
  //   }, 20000);
  // }, []);

  if (userType === null) {
    logout();
  }
  useEffect(() => {
    setPageName(pageName.paymentConfirm);
    localStorage.removeItem('lmrchecked');
  }, []);
  useEffect(() => {
    dispatch(setAppBarTitle('Collect your order'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));

    // setTimeout(() => {
    //   setShowOfferPopup(false);
    // }, 100000);

    timer11 = window.setTimeout(() => {
      window.Moengage.destroy_session();
      if (userType === 'employee') {
        const userType = getUserType();
        localStorage.clear();
        if (userType != null) {
          setUserType(userType);
          setThankyou();
          window.location.href = '/thankyou';
        }
      } else {
        // setShowThankyou(true);
      }
    }, 60000);

    onPayConfirmMoengage(currentOrderResp);

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
      dispatch(resetOrderState());
      dispatch(setCartItemsCount(0));

      setTotalCartItems(0);
      clearTimeout(timer11);
      clearTimeout(thankyouTimer);
      if (isWhatsappEnrolled === true) {
        whatsAppGtmStatus(whatsAppStatusMesages.optin);
      } else {
        whatsAppGtmStatus(whatsAppStatusMesages.notOpted);
      }
    };
  }, []);

  useEffect(() => {
    if (isWhatsappEnrolled) {
      setOptIn(true);
    }
  }, [isWhatsappEnrolled]);

  useEffect(() => {
    if (mobile) {
      dispatch(
        checkWhatsappStatus({
          searchColumn: 'number',
          searchValue: `91${mobile}`,
        }),
      );
    }
  }, []);
  const onPayConfirmMoengage = (currentOrderResp: OrderResponse | null) => {
    if (currentOrderResp != null) {
      let productPrices = '';
      let productNames = '';
      let productsId = '';
      let productsBrand = '';

      currentOrderResp.itemList?.map((itemData, index, array) => {
        if (index === array.length - 1) {
          productPrices += itemData.extSellPrice.toString();
        } else {
          productPrices += itemData.extSellPrice + ' , ';
        }
      });

      if (currentOrderResp.productList != null) {
        const obj = Object.entries(currentOrderResp.productList).map(
          ([key, value]) => ({
            value,
          }),
        );

        //   }
        // }
        obj.map((itemData, index, array) => {
          if (index === array.length - 1) {
            productsBrand += itemData.value.itemBrand.toString();
            productsId += itemData.value.itemID.toString();
            productNames += itemData.value.itemDesc.toString();
          } else {
            productsBrand += itemData.value.itemBrand + ' , ';
            productsId += itemData.value.itemID + ' , ';
            productNames += itemData.value.itemDesc + ' , ';
          }
        });
      }

      console.log(productPrices);

      const orderDetail: orderDetailInfo = {
        product_ID: productsId,
        product_Name: productNames,
        price: productPrices,
        brand: productsBrand,
        eventName: eventNames.eventBillingEvent,
        event: orderCompleteEvent,
        orderID: currentOrderResp.orderId,
        payment_Mode: paymentMode,
        purchaseDate: new Date().toDateString().toString(),
        //order_Address_City:string;
        // first_Name: string;
        //last_Name:string;
        //category_Name:string;
        //category_Type:string;
      };
      checkoutGtmData(orderDetail);
    }
  };

  function handleModalClose() {
    setShowOfferPopup(false);
  }

  // useEffect(() => {
  //   if (!invoiceResp) {
  //     navigate.push('/checkout');
  //   }
  // }, []);

  function handleOnRedIconClick() {
    const phoneNum = getPhoneNumber();
    setShowThankyou(false);
    setShowFeedback(true);
    beginFeedback(currentOrderResp.orderId,phoneNum)
  }

  function handleNoClick(feedback: string) {
    setShowFeedback(false);
    setShowThankyou(true);
    setThankYouType('default');
    const accessToken = getAccessToken();
    const phoneNum = getPhoneNumber();
    if (currentOrderResp != null && accessToken != null && phoneNum != null) {
      const parameters = {
        payload: {
          feedback: feedback,
          cardNumber: currentOrderResp.cardNumber,
          orderId: currentOrderResp.orderId,
          mobileNo: '',
        },
        accessToken: accessToken,
      };
      submitFeedback(feedback,currentOrderResp.orderId,phoneNum);
      dispatch(feedbackCustomer(parameters));
    }
  }
  function sendOrderidSms() {
    if (currentOrderResp !== null && accessToken != null) {
      const parameters = {
        accessToken: accessToken,
        payload: {
          orderId: currentOrderResp.orderId,
        },
      };

      dispatch(smsorderIdBySms(parameters));
    }
  }

  function handleYesClick(feedback: string) {
    setShowFeedback(false);
    setShowThankyou(true);
    setThankYouType('connect');
    const accessToken = getAccessToken();
    const phoneNum = getPhoneNumber();
    if (currentOrderResp != null && accessToken != null && phoneNum != null) {
      const parameters = {
        payload: {
          feedback: feedback,
          cardNumber: currentOrderResp.cardNumber,
          orderId: currentOrderResp.orderId,
          mobileNo: phoneNum,
        },
        accessToken: accessToken,
      };
      submitFeedback(feedback,currentOrderResp.orderId,phoneNum);
      dispatch(feedbackCustomer(parameters));
    }
  }

  function renderPage() {
    if (showThankyou) {
      return (
        <Thankyou onRedIconClick={handleOnRedIconClick} type={thankYouType} />
      );
    } else if (showFeedback) {
      return (
        <NegativeFeedback
          onNoClick={handleNoClick}
          onYesClick={handleYesClick}
        />
      );
    } else {
      return (
        <>
          <div className="flex flex-nowrap flex-col m-auto pt-4 px-6">
            <div className="stepper-container-horizontal mb-6">
              <Stepper />
            </div>
            <div>
              <div className="flex justify-center items-center mb-2">
                <div className="">
                  <img src={GreenCheckIcon} />
                </div>
                <div className="md:text-big font-roboto font-light">
                  Purchase Successful
                </div>
              </div>
              <div className="font-roboto text-small text-center">
                Order ID <strong>{currentOrderResp?.orderId}</strong> has been
                processed
              </div>
              {!invoiceResp ? (
                <div>
                  <br />
                  <div className="font-roboto text-small text-center">
                    <b>{errorMessage}</b>
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className="mt-2 text-small text-black font-roboto text-opacity-50">
                {mobile
                  ? `The e-invoice can be downloaded at your WhatsApp with your registered mobile number ending with ${mobile.slice(
                      mobile.length - 4,
                    )}.`
                  : `The e-invoice can be downloaded at your WhatsApp with your registered mobile number.`}
              </div>
              <div className="flex items-center py-5">
                <div className="checkbox-wrapper block m-auto">
                  <label className="text-xxs font-roboto checkbox-container flex items-center">
                    <span className="flex items-center flex-wrap h-7 pt-1 text-black text-opacity-50">
                      Receive notifications and bills on&nbsp;
                      <span className="flex items-center h-6 text-black">
                        <strong>WhatsApp</strong>
                        <img src={WhatsappIcon} width="19" height="20" />
                      </span>
                    </span>
                    <input
                      type="checkbox"
                      name="whatsappApi"
                      checked={optInTrue}
                      onChange={() => {
                        if (optInTrue === true) {
                          setOptIn(false);
                          false;
                        } else {
                          setOptIn(true);
                          if (mobile) {
                            dispatch(whatsApi({mobile}));
                          }
                        }
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
              <div className="flex place-content-center">
                {userType === 'employee' ? (
                  <button
                    className="text-white h-12 rounded-radius10 mt-2 mb-10 grid place-items-center focus:outline-none text-center secondary normal px-4"
                    onClick={sendOrderidSms}>
                    <p className="font-bold font-roboto">SMS order number</p>
                  </button>
                ) : (
                  <button
                    className="text-white h-12 rounded-radius10 mt-2 mb-10 grid place-items-center focus:outline-none text-center secondary normal px-4"
                    onClick={() => {
                      setShowThankyou(false);
                      setShowOrderSummaryModal(true);
                    }}>
                    <p className="font-bold font-roboto">View order summary</p>
                  </button>
                )}
              </div>
            </div>
            <div className="flex justify-between relative">
              <div className="confirm-proceed font-roboto w-9/12 pl-4 pr-20 py-2 shadow-max">
                <div className="font-medium text-small mb-4">
                  Instructions to proceed
                </div>
                <div className="text-small mb-1">
                  1. Go to the nearest checkout counter
                </div>
                <div className="text-small mb-1">
                  2. Show the order number shared with you
                </div>
                <div className="text-small mb-1">3. Get tags removed</div>
                <div className="text-small mb-1">4. Collect your product</div>
              </div>
              <div className="confirm-qrcode bg-white absolute border-1 border-gray-300 border-solid h-36 left-48 rounded-full top-9 w-36">
                {/* <img
              className="m-auto absolute left-inset20 top-inset20"
              src={npQRCode}
            /> */}
                {currentOrderResp && (
                  <div className="m-auto absolute left-inset20 top-inset20">
                    <QRCode value={currentOrderResp.orderId} size={90} />
                  </div>
                )}
              </div>
            </div>
            {showOfferPopup && (
              <Offer open={showOfferPopup} onClose={handleModalClose} />
            )}
          </div>
        </>
      );
    }
  }

  return (
    <>
      {renderPage()}
      <CustomModal
        isVisible={showOrderSummaryModal}
        classNames="top-20 md:top-72"
        onClose={() => {
          // setTimeout(() => {
          //   setShowThankyou(true);
          // }, 10000);
          setShowOrderSummaryModal(false);
        }}>
        <OrderSummary orderResp={currentOrderResp} />
      </CustomModal>
    </>
  );
};

export default CheckoutConfirm;
